import { BasicColumnTypes } from '@opengov/ogql-types';
import {
  BooleanOperators,
  UnifiedLedgerType,
  UnifiedLedgerTypeDisplay,
  IColumnFilterComparison,
  IColumnFilterMDS,
  IProjection
} from '@opengov/reporting-types';
import { IColumnOptionSegment } from './ColumnOptionTypes';

export enum enumActiveNavigationPanelFilter {
  ROOT = 'Root page',
  FILTER = 'Filter page'
}

export enum EFileFormat {
  Csv = 'CSV'
}

export enum EDownloadStatus {
  Success = 'SUCCESS',
  Failure = 'FAILURE'
}

export enum EditPanelContents {
  EditColumn = 'EditColumn',
  EditSubColumn = 'EditSubColumn',
  EditRow = 'EditRow',
  EditMultiHierarchyRow = 'EditMultiHierarchyRow',
  EditMultiHierarchyColumn = 'EditMultiHierarchyColumn',
  EditOverrideRow = 'EditOverrideRow',
  EditMultiHierarchyOverrideRow = 'EditMultiHierarchyOverrideRow',
  EditCalculatedColumn = 'EditCalculatedColumn',
  EditCalculatedRow = 'EditCalculatedRow',
  EditMultiHierarchyCalculatedRow = 'EditMultiHierarchyCalculatedRow',
  EditMultiHierarchyCalculatedColumn = 'EditMultiHierarchyCalculatedColumn'
}

export enum EEditMode {
  Default = 'Default',
  RowNew = 'RowNew',
  RowEdit = 'RowEdit',
  ColEdit = 'ColEdit',
  SubColEdit = 'SubColEdit',
  ColNew = 'ColNew'
  // Add more modes here as needed.
}

export enum enumValidFilterColumnTypes {
  Text = 'urn:opengov:types/logical/text',
  TextCode = 'urn:opengov:types/logical/text-ci',
  Numeric = 'urn:opengov:types/logical/numeric'
}

export type IColumnFilterMultiDataset = Omit<IColumnFilterComparison, 'columnName'> & {
  booleanOperator?: BooleanOperators;
};

export interface IInfoCOA {
  dimensionId: string | undefined;
  joinColumnName: string | undefined;
}
export type IColumnFilterListMDS = {
  name: string;
  label: string;
  type: BasicColumnTypes;
  filters: IColumnFilterMultiDataset[];
  booleanOperator?: BooleanOperators;
  infoCOA?: IInfoCOA;
};
export interface ISelectOption {
  label: string;
  value: string;
  children?: ISelectOption[];
  disabled?: boolean;
  tooltip?: string;
}

export interface ISelectOptionsBlock {
  label?: string;
  options: ISelectOption[];
}

export interface IRowOption extends ISelectOption {
  label: UnifiedLedgerTypeDisplay;
  value: UnifiedLedgerType;
  row: IColumnOptionSegment[];
}

export type RowGroupOptions = {
  [key in UnifiedLedgerType]?: IRowOption;
};

export interface ISelectedRowShowOption {
  label: string;
  value: string;
}

export interface ISelectedRowOption {
  label: string;
  value: string;
  parent: string;
}
export interface ISelectedRow {
  show: ISelectedRowShowOption;
  row: ISelectedRowOption;
}

export interface IGroupBy {
  column: string;
  dimensionId?: string;
}

export interface IRowEditorSetupFormValues {
  show: UnifiedLedgerType;
  groupBy: IGroupBy[];
  groupName: string;
}

export type IRowEditorFormValues = IRowEditorSetupFormValues & {
  filters: IColumnFilterMDS<IProjection>[];
};

export interface ISegmentOption {
  lensId: string;
  label: string;
  name: string;
  disabled?: boolean;
  dimensionColumns?: { label: string; name: string }[];
  dimensionId?: string;
  index: number;
}

export interface IColumnNameFilters {
  [columnName: string]: IColumnFilterListMDS | undefined;
}
